/* ═══════════════════════════════════════════════════════════════
   ForecastConfirmService — Meeting mode "Time's good ✓" stamps.

   Deliberately its own tiny file (not folded into timeService.ts) —
   Tranche 3 file territory keeps timeService.ts untouched while a second
   agent works on it concurrently. Mirrors timeService's forecast helpers
   one-for-one: queryAdvanced for range reads, a bespoke server action
   (not generic table CRUD) for the write so the CALLER is always the
   stamped confirmer, never a client-supplied id.
   ═══════════════════════════════════════════════════════════════ */

import type { ForecastConfirm } from '../../shared/entities';
import * as cache from './cloudCache';
import * as cloudApi from './apiClient';

const TABLE = 'forecast_confirms';

export const ForecastConfirmService = {
  /** All confirm stamps whose week_start_date falls in [startWeek, endWeek],
   *  optionally narrowed to a set of members (mirrors
   *  TimeService.listForecastsForRange). */
  listForRange: async (
    startWeek: string,
    endWeek: string,
    memberIds?: string[]
  ): Promise<ForecastConfirm[]> => {
    const filters: { col: string; op: string; val: any }[] = [
      { col: 'week_start_date', op: '>=', val: startWeek },
      { col: 'week_start_date', op: '<=', val: endWeek },
    ];
    if (memberIds && memberIds.length > 0) {
      filters.push({ col: 'team_member_id', op: 'IN', val: memberIds });
    }
    return cache.queryAdvanced<ForecastConfirm>(TABLE, filters);
  },

  /** Stamp "Time's good" for one member's week. Idempotent — re-confirming
   *  just refreshes confirmedBy/confirmedAt (unique on member+week). */
  confirmWeek: async (teamMemberId: string, weekStart: string): Promise<ForecastConfirm> => {
    const result = await cloudApi.forecastConfirmWeek({ teamMemberId, weekStart });
    cache.invalidate(TABLE);
    return result;
  },
};
